import type { AxiosInstance, AxiosRequestHeaders } from "axios";

type DeviceType = "mobile" | "web";

export const createApiHeaders = (
  device: DeviceType,
  lang = "pl",
): AxiosRequestHeaders => ({
  "Accept-Language": lang,
  "Device-Type": device,
});

let axiosInstance: AxiosInstance | null = null;

export const setAxiosInstance = (instance: AxiosInstance) => {
  axiosInstance = instance;
};

export const getAxiosInstance = (): AxiosInstance => {
  if (!axiosInstance) {
    throw new Error(
      "Axios instance is not set. Please call setAxiosInstance first.",
    );
  }
  return axiosInstance;
};

export const fetcher = (url: string) => {
  if (!axiosInstance) {
    throw new Error(
      "Axios instance is not set. Please call setAxiosInstance first.",
    );
  }
  return axiosInstance.get(url).then((res) => res.data);
};

export function updateAxiosHeaders(device: DeviceType, lng: string) {
  if (!axiosInstance) {
    throw new Error(
      "Axios instance is not set. Please call setAxiosInstance first.",
    );
  }
  axiosInstance.defaults.headers.common = createApiHeaders(device, lng);
}
